var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"chart-container"},[_c('canvas',{attrs:{"id":"vehicle-state-chart-canvas","width":"400","height":"400"}})])
}]

export { render, staticRenderFns }